import React from 'react';
import { Modal } from '../../../components/ui/Modal';
import { Button } from '../../../components/ui/Button';
import { Input } from '../../../components/ui/Input';
import { Organization } from '../../../types/domain';
import { Trash2 } from 'lucide-react';

interface DeleteOrgModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentOrg: Organization | null;
  confirmText: string;
  onConfirmTextChange: (val: string) => void;
  isDeleting: boolean;
  onDelete: () => void;
}

export const DeleteOrgModal: React.FC<DeleteOrgModalProps> = ({
  isOpen,
  onClose,
  currentOrg,
  confirmText,
  onConfirmTextChange,
  isDeleting,
  onDelete,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => !isDeleting && onClose()}
      title="Confirm Organization Deletion"
      maxWidth="md"
    >
      <div className="space-y-4">
        <div className="p-3 bg-rose-500/10 border border-rose-500/30 rounded-lg text-xs text-rose-400 space-y-1">
          <span className="font-semibold block">Warning: Irreversible Data Loss</span>
          <p className="text-cf-textSecondary leading-relaxed">
            Deleting <strong>{currentOrg?.name}</strong> will permanently wipe all associated projects, tables, dynamic form submissions, and all stored files from S3/storage.
          </p>
        </div>

        <p className="text-xs text-cf-textSecondary">
          To confirm deletion, please enter the organization slug <code className="text-rose-400 font-mono font-bold">{currentOrg?.slug}</code> below:
        </p>

        <Input
          size="xs"
          value={confirmText}
          onChange={(e) => onConfirmTextChange(e.target.value)}
          placeholder={currentOrg?.slug}
          className="border-rose-500/40 font-mono"
          autoFocus
        />

        <div className="flex justify-end gap-2.5 pt-2 border-t border-cf-border">
          <Button
            variant="secondary"
            size="xs"
            disabled={isDeleting}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            size="xs"
            disabled={isDeleting || confirmText !== currentOrg?.slug}
            isLoading={isDeleting}
            onClick={onDelete}
            leftIcon={<Trash2 size={13} />}
          >
            Permanently Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};
